/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);  
};

jQuery(function($) {
                    
  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumb a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );
  
});

$( ".product-in-grid" ).hover(
  function() {
    $( this ).children( ".hover-image" ).show();
  }, function() {
    $( this ).children( ".hover-image" ).hide();
  }
);

$( ".label-swatch-color" ).click(function() {
  $( ".label-swatch-color" ).css( "color", "#bdbdbd" );
  $( ".label-swatch-color" ).css( "border", "1px solid #bdbdbd" );
  $( this ).css( "color", "#000" );
  $( this ).css( "border", "1px solid #000" );
});

$( ".label-swatch-color.available" ).click(function() {
  $("#add").attr("value","ADD TO CART");
  $("#add").css("pointer-events","auto");
  $("#add").css("background-color","transparent");
  $("#add").css("color","black");
});


$( ".label-swatch-color.soldout" ).click(function() {
  $("#add").attr("value","SOLD OUT");
  $("#add").css("pointer-events","none");
  $("#add").css("background-color","black");
  $("#add").css("color","white");
});

$( ".about-button-scroll" ).click(function() {
  $( ".about-button-scroll" ).toggleClass( "active" );
  $( ".about-scroll-vertical-desk-container" ).toggle();
  $( ".template-index .claim-camisas" ).toggle();
});

$( "#size-button" ).click(function() {
  $( ".shopify-section-size-guide" ).toggle();
});

$( "#size-button" ).click(function() {
  $( "#shopify-section-ship" ).hide();
});

$( "#close-button-size-guide" ).click(function() {
  $( ".shopify-section-size-guide" ).hide();
});

$( "#ship-button" ).click(function() {
  $( "#shopify-section-ship" ).toggle();
});

$( "#ship-button" ).click(function() {
  $( ".shopify-section-size-guide" ).hide();
});

$( "#close-button-ship" ).click(function() {
  $( "#shopify-section-ship" ).hide();
});

$( "#mobile-burger" ).click(function() {
  $( "#mobile-menu" ).toggle();
  $( ".burger-line-first" ).toggleClass( "burger-line-first-close" );
  $( ".burger-line-middle" ).toggleClass( "burger-line-middle-close" );
  $( ".burger-line-last" ).toggle();
});

$( ".about-scroll-vertical-desk-container" ).click(function() {
  $( this ).hide();
  $( ".about-button-scroll" ).removeClass( "active" );
});

// Book an appointment: abre el calendario precargado; si no existe, muestra el formulario de contacto
$( ".made-to-measure-book" ).click(function() {
  if ( window.cmOpenBooking ) {
    window.cmOpenBooking();
  } else {
    $( ".form-container" ).show();
    $( "#contact_form" ).show();
  }
});

$( ".made-to-measure-contact" ).click(function() {
  $( ".form-container" ).show();
  $( "#contact_form" ).show();
});

$( ".form-container" ).click(function() {
  $( this ).hide();
  $( "#contact_form" ).hide();
});

$( document ).ready(function() {
  $( ".product-in-grid.sold-out" ).children( ".product-grid-info" ).children( ".product-grid-price-link" ).text( "SOLD OUT" );
  $('body').fadeTo(300, 1);
  
  $("#agree").change(function() {
    $( "#checkout" ).toggleClass( "active-check" );
  });
  
  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            l.src = l.dataset.src;
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }


  // NEWSLETTER
  $( "#newsletter-footer-trigger" ).click(function() {
    $( "#subscribe-form" ).show();
  });
  $( "#close-newsletter" ).click(function() {
    $( "#subscribe-form" ).hide();
    Cookies.set("cookies", "1");
  });
  var galleta = Cookies.get("cookies")
  if (galleta != undefined && galleta != ''){
  } else {
    setTimeout(function(){
      $( "#subscribe-form" ).show();
    }, 5000);
  }
  
});
















